export default function RadioGroup(theme) {
	return {
		MuiFormGroup: {
			styleOverrides: {
				root: {
					rowGap: 16,
					".MuiFormControlLabel-root": {
						marginLeft: 0,
						marginRight: 0,
						columnGap: 10,
						".MuiTypography-root": {
							color: theme.palette.secondary.main,
							fontSize: 16,
							fontWeight: 400,
							lineHeight: 1.5,
							fontFamily: "'General Sans', sans-serif",
						},
					},
					".MuiRadio-root": {
						padding: 0,
						".MuiSvgIcon-root": {
							width: 24,
							height: 24,
						},
					},
				},
			},
		},
	};
}
